import { FontAwesomeIcon } from "components/FontAwesomeIcon";
import type React from "react";
import { useTranslation } from "react-i18next";
import { ParagraphMedium } from "styles/elements/Texts";
import {
  StyledCard,
  StyledCardContent,
  StyledCardHeader,
  StyledTitleChip,
} from "./CardWithTitleChip.styled";

interface CardWithTitleChipProps {
  children: React.ReactNode;
  className?: string;
  dataCy?: string;
  title: string;
  comingSoon?: boolean;
  onClick?: () => void;
}

/**
 *  Component used to render a panel, consisting on a card with a title Chip.
 *
 *  The user must specify the title to display in the Chip.
 *
 *  This component will receive the panel contents as children elements, like portrayed
 * in below's example:
 *
 *    <CardWithTitleChip title="My panel">
 *      <p>This is the content of my panel</p>
 *      <p>There can be multiple elements inside</p>
 *    </CardWithTitleChip>
 *
 */
export const CardWithTitleChip: React.FC<CardWithTitleChipProps> = ({
  children,
  className,
  dataCy,
  title,
  onClick,
  comingSoon = false,
}) => {
  const { t } = useTranslation("homepage");
  return (
    <StyledCard className={className} data-cy={dataCy} flexDirection="column" onClick={onClick}>
      <StyledCardHeader alignItems="center" flexDirection="row" gap={0.5}>
        <StyledTitleChip data-cy={`${dataCy}-title`}>
          <ParagraphMedium>{title}</ParagraphMedium>
        </StyledTitleChip>
        {comingSoon && (
          <StyledTitleChip data-cy="coming-soon-chip" $comingSoon={comingSoon}>
            <FontAwesomeIcon iconName="fas fa-star" fontSize="12px" />
            <ParagraphMedium>{t("studentDashboard.comingSoonModules.comingSoon")}</ParagraphMedium>
          </StyledTitleChip>
        )}
      </StyledCardHeader>
      <StyledCardContent flexDirection="column" flexGrow={1} gap={1} justifyContent="space-between">
        {children}
      </StyledCardContent>
    </StyledCard>
  );
};
